import {
  AddDevice_AddDeviceCommand,
  ControlBlocksService,
  DevicesService,
} from "../api";
import {SystemDevices} from "../components/menu/ExternalDevices/components/AddExternalDevicesWidget/AddExternalDevicesWidget.model";
import {mapConnectedExternalDevicesResponse} from "../shared/Helpers.utils";

export const ExternalDevicesApi  = {

  //Получение подключенных устройств
  getExternalDevices: async (id: string | undefined): Promise<SystemDevices> => {
    const response = await ControlBlocksService.getApiControlBlocksDevicesConnected(String(id));
    return mapConnectedExternalDevicesResponse(response as Record<string, unknown>);
  },

  //Получение информации по устройству
  getDeviceInfo: async (id: string | undefined, address: number | string, type: number | string): Promise<any> => {
    return DevicesService.getApiDevicesDeviceType(
      String(id),
      Number(address),
      Number(type),
    );
  },

  // Добавить устройство
  addDevice: async (payload: any): Promise<boolean> => {
    await DevicesService.postApiDevices(payload as AddDevice_AddDeviceCommand);
    return true;
  },

  // Удалить устройство
  deleteDevice: async (id: string): Promise<boolean> => {
    await DevicesService.deleteApiDevices(id);
    return true;
  },

  // Обновить адрес устройства
  updateAddress: async (
    controlBlockId: string | undefined,
    type: number | string,
    oldAddress: number | string,
    newAddress: number | string
  ): Promise<boolean> => {
    await DevicesService.getApiDevicesDeviceTypeSerial(
      String(controlBlockId),
      Number(oldAddress),
      Number(type),
      Number(newAddress),
    );

    return true;
  },

}
